import { WeightUnit } from '../../../graphql'

/**
 * Above this weight, small-parcel carriers (UPS/FedEx Ground, Next Day Air,
 * etc.) won't move the item — it has to go LTL freight regardless of the
 * shipping speed requested.
 *
 * This is the only rule we can key off of right now: dimensions, glass/
 * fragile classification, and carton counts aren't reliably available on
 * Part/ItemMasterVariant today.
 *
 */
export const LTL_MIN_WEIGHT_LBS = 99

const POUNDS_PER_UNIT: Record<WeightUnit, number> = {
	[ WeightUnit.Lb ]: 1,
	[ WeightUnit.Kg ]: 2.20462,
	[ WeightUnit.Oz ]: 1 / 16,
}

export function toPounds( value: number, unit: WeightUnit ): number {
	return value * POUNDS_PER_UNIT[ unit ]
}

export type PartFreightDetails = {
	itemMasterVariant?: {
		weight?: {
			amount: number | string,
			unit: WeightUnit,
		} | null,
	} | null,
} | null | undefined

/**
 * Returns a user-facing explanation when a part's weight forces it into LTL
 * freight, or null when it's within small-parcel carrier limits.
 */
export function getLtlShipmentReason( part: PartFreightDetails ): string | null {
	const weight = part?.itemMasterVariant?.weight
	if ( !weight ) {
		return null
	}

	if ( toPounds( Number( weight.amount ), weight.unit ) > LTL_MIN_WEIGHT_LBS ) {
		return 'This item is too big or heavy and must ship LTL freight.'
	}

	return null
}
